import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import Seo from "./Seo";
import Navbar from "./component/common/Navbar";

// Import Firebase SDKs
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import FAQ from "./Pages/FAQ";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Terms from "./Pages/Terms";
import HelpSection from "./Pages/HelpCenter";
import Rainbow from "./component/Rainbow/Rainbow";
import Glowing from "./component/Rainbow/Glowing";
import Business from "./Pages/Business";
import About from "./Pages/About";
import Explore from "./Pages/Explore";
// Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyDEPvWga6mBXSwM71Cl8RNrXsnZW8Ng7O8",
  authDomain: "weplay-web-7e562.firebaseapp.com",
  projectId: "weplay-web-7e562-73332",
  storageBucket: "weplay-web-7e562.firebasestorage.app",
  messagingSenderId: "85432023332",
  appId: "1:85432023332:web:31277cc331ad5d54c6dbb1",
  measurementId: "G-YC8S45GS8J",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

function App() {
  // Add state to hold particle positions
  const [particles, setParticles] = React.useState(
    [...Array(50)].map(() => ({
      offsetX: 0,
      offsetY: 0,
      animationDelay: `${Math.random() * 5}s`,
    }))
  ); // Initialize particles with default properties

  // Function to update particle positions based on mouse movement
  const handleMouseMove = (e) => {
    const newParticles = particles.map((particle) => ({
      ...particle,
      offsetX: (e.clientX / window.innerWidth) * 10 - 5, // Adjust movement based on mouse position
      offsetY: (e.clientY / window.innerHeight) * 10 - 5,
    }));
    setParticles(newParticles);
  };

  // Add event listener for mouse movement
  React.useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [particles]);

  return (
    <div style={{ background: "#000" }} className="App">
      {/* Animated background elements */}


      <Seo />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/business" element={<Business />} />
        <Route path="/about" element={<About />} />
        <Route path="/explore" element={<Explore />} />

        <Route exact path="/faqs" element={<FAQ />} />
        <Route exact path="/terms-and-conditions" element={<Terms />} />
        <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/help-center" element={<HelpSection />} />

      </Routes>
    </div>
  );
}

export default App;
